import * as React from "react";
import { SpinnerWrapper, AlertMessage, AlertType, CustomButton, ButtonType, TextInput } from "soprasteria-ui-library";
import { useAuth } from "../../../App";
import { EmailSettingApi } from "../../../api/EmailSettingApi";
import { IEmailSetting, ICreateOrUpdateEmailSetting } from "../../../models/IEmailSetting";
import { setMessage } from "../../../helpers/MessageHelper";
import { EmailSettingModal } from "./EmailSettingModal";


export const EmailSetting: React.FunctionComponent<{}> = () => {
    const auth = useAuth();
    const api = new EmailSettingApi(auth);

    const [isLoadingEmailSetting, setIsLoadingEmailSetting] = React.useState<boolean>(false);
    const [emailSetting, setEmailSetting] = React.useState<IEmailSetting>();
    const [errorMessage, setErrorMessage] = React.useState<string>("");
    const [successMessage, setSuccessMessage] = React.useState<string>("");
    const [renderModal, setRenderModal] = React.useState<boolean>(false);
    const [sendingTestEmail, setSendingTestEmail] = React.useState<boolean>(false);

    React.useEffect(() => {
        loadEmailSetting();
    }, []);

    const loadEmailSetting = () => {
        setIsLoadingEmailSetting(true);
        api.getEmailSetting((data: IEmailSetting) => {
            setEmailSetting(data);
            setIsLoadingEmailSetting(false);
        }, (message) => {
            const newErrorMessage = setMessage(message, errorMessage);
            setErrorMessage(newErrorMessage);
        });
    }

    const closeModal = () => {
        setRenderModal(false);
    }

    const onSubmit = (createOrUpdateEmailSetting: ICreateOrUpdateEmailSetting, onCallEnd?: () => void) => {
        if (createOrUpdateEmailSetting.emailSettingId === "-1") {
            api.createEmailSetting(createOrUpdateEmailSetting, () => {
                loadEmailSetting();
                const newMessage = setMessage("E-postinställningen har registrerats", successMessage ?? "");
                setSuccessMessage(newMessage);
                if (onCallEnd) {
                    onCallEnd();
                }
            }, (message) => {
                const newErrorMessage = setMessage(message, errorMessage);
                setErrorMessage(newErrorMessage);
            });
        } else {
            api.updateEmailSetting(parseInt(createOrUpdateEmailSetting.emailSettingId), createOrUpdateEmailSetting, () => {
                loadEmailSetting();
                const newMessage = setMessage("E-postinställningen har uppdaterats", successMessage ?? "");
                setSuccessMessage(newMessage);
                if (onCallEnd) {
                    onCallEnd();
                }
            }, (message) => {
                const newErrorMessage = setMessage(message, errorMessage);
                setErrorMessage(newErrorMessage);
            });
        }

        document.getElementById("close-email-setting-modal")?.click();
    }

    const onSendTestMail = () => {
        var sendTestMail = window.confirm("Ett e-postmeddelande kommer att skickas till din angivna e-postadress. Är du säker?");
        if (sendTestMail && emailSetting?.emailSettingId) {
            setSendingTestEmail(true);
            api.createTestEmail(emailSetting.emailSettingId, () => {
                const newMessage = setMessage("Ett e-postmeddelande skickas till din angivna e-postadress. Kontrollera att det kommit fram.", successMessage ?? "");
                setSuccessMessage(newMessage);
                setSendingTestEmail(false);
            }, (message) => {
                const newErrorMessage = setMessage(message, errorMessage);
                setErrorMessage(newErrorMessage);
            });
        }
    }

    return (
        <SpinnerWrapper isLoading={isLoadingEmailSetting}>
            <section className="card">
                <div className="card-header">
                    <div className="row">
                        <div className="col">
                            <h1>E-postinställningar</h1>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <AlertMessage alertType={AlertType.success} duration={3000}>{successMessage}</AlertMessage>
                    <AlertMessage alertType={AlertType.danger} duration={3000}>{errorMessage}</AlertMessage>
                    <div className="panel text-right">
                        <div className="btn-group" role="group">
                            {
                                emailSetting && emailSetting.emailSettingId ?
                                    <CustomButton buttonType={ButtonType.edit} onClick={() => setRenderModal(true)} buttonText="Redigera e-postinställning" />
                                    : <CustomButton buttonType={ButtonType.create} onClick={() => setRenderModal(true)} buttonText="Registrera e-postinställning" />
                            }
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <TextInput name="emailAddress" label="E-postadress" labelCol={3} inputCol={9} defaultValue={emailSetting?.emailAddress ? emailSetting.emailAddress : "Ej angivet"} readonly inlineLabel />
                            <TextInput name="emailPeriodicity" label="Tidsintervall" labelCol={3} inputCol={9} defaultValue={emailSetting?.emailPeriodicity?.description ? emailSetting.emailPeriodicity.description : "Ej angivet"} readonly inlineLabel />
                        </div>
                    </div>
                    {
                        renderModal && emailSetting
                            ?
                            <EmailSettingModal emailSetting={emailSetting} closeModal={closeModal} onSubmit={onSubmit} />
                            : null
                    }
                </div>
                {
                    emailSetting && emailSetting.emailSettingId ?
                        <div className="card-footer">
                            <div className="row">
                                <div className="col-12 text-right">
                                    <CustomButton buttonType={ButtonType.createAlt} onClick={onSendTestMail} isLoading={sendingTestEmail} buttonText="Skicka ett testmail" />
                                </div>
                            </div>
                        </div> : null
                }
                
            </section>
        </SpinnerWrapper>
    )
}